import React, {Component} from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { Container, MainHome, BlockContent}  from './styles';
import NavegationComponent from '../navegationMenu';
import HeaderModuleComponent from '../headerModule';

class Home extends Component {
  render() {
    console.log(this.props.routes);
    if (localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null) {
      return (
        <Router>
          <Container>
            <NavegationComponent />
              <MainHome>
              <HeaderModuleComponent />
              <BlockContent>
              <Switch>
                  {
                  this.props.routes.map(route => (
                  <Route
                  key={route.path}
                  path={route.path}
                  component={route.component}
                  exact={route.exact}
                  />
                  ))}
                  </Switch>           
              </BlockContent>
            </MainHome>
          </Container>
        </Router>
      );
    } else {
      //limpio localstorage
      localStorage.clear();
      //volver al login
      window.location = '/';
    }
  }
}

export default Home; 